import React, { FunctionComponent, useMemo } from 'react';
import SectionLoader from '../../../../../../common/components/loaders/SectionLoader';
import variantDataExtractor from '../../../../../../gqlCommon/service/variantDataExtractor';
import { IVariant } from '../../../../../../gqlCommon/model/IVariants';
import marketingCategoryService from '../../../../../../gqlCommon/service/marketingCategoryService';
import VariantList from './VariantList';
import SpecificationsAndFeaturesContainer from '../../variantSelector/specificationsAndFeatures/SpecificationsAndFeaturesContainer';

interface IVariantListContainerProps {
  selectedMarketingCategory?: string;
  isLoadingVariants: boolean;
  variants: IVariant[];
  model: string;
  selectedVariantId: string;
  changeVariant: (variantId: string) => void;
}

const VariantListContainer: FunctionComponent<IVariantListContainerProps> = ({
  selectedMarketingCategory,
  isLoadingVariants,
  variants,
  model,
  selectedVariantId,
  changeVariant,
}) => {
  const variantsByMarketCategory = marketingCategoryService.getVariantsByMarketingCategory(
    variants,
    selectedMarketingCategory,
  );
  const selectedVariantData = useMemo(
    () => variantDataExtractor.getVariantByVariantId(variants, selectedVariantId),
    [selectedVariantId, variants],
  );

  if (isLoadingVariants && !variantsByMarketCategory.length) {
    return <SectionLoader />;
  }

  return (
    <VariantList
      variants={variantsByMarketCategory}
      model={model}
      selectedVariantId={selectedVariantId}
      selectVariantId={changeVariant}
      detailsSlot={<SpecificationsAndFeaturesContainer selectedVariant={selectedVariantData} />}
    />
  );
};

export default VariantListContainer;
